<script setup lang="ts">
import { computed, reactive } from "vue";
import CryptoJS from "crypto-js";
import { $t } from "@/locales";
import { loginModuleRecord } from "@/constants/app";
import { useRouterPush } from "@/hooks/common/router";
import { useFormRules, useNaiveForm } from "@/hooks/common/form";
import { useAuthStore } from "@/store/modules/auth";
import { appUuid, channel } from "@/constants/apiConfig";

defineOptions({
  name: "PwdLogin",
});

const authStore = useAuthStore();
const { toggleLoginModule } = useRouterPush();
const { formRef, validate } = useNaiveForm();

interface FormModel {
  account: string;
  password: string;
  appUuid: string;
  channel: string;
}

const model: FormModel = reactive({
  // account: "822358327@qq.com",
  // password: "qqqq1111",
  account: "",
  password: "",
  appUuid,
  channel,
});

const rules = computed<
  Record<keyof Pick<FormModel, "account" | "password">, App.Global.FormRule[]>
>(() => {
  const { formRules } = useFormRules();

  return {
    account: formRules.account,
    password: formRules.pwd,
  };
});

async function handleSubmit() {
  await validate();
  await authStore.login(
    model.account,
    CryptoJS.SHA256(model.password).toString(),
    model.appUuid,
    model.channel,
  );
}
</script>

<template>
  <NForm ref="formRef" :model="model" :rules="rules">
    <NFormItem :label="$t('form.account.label')" path="account" :show-require-mark="false">
      <NInput v-model:value="model.account" :placeholder="$t('form.account.placeHolder')" clearable
        @keyup.enter="handleSubmit">
        <template #prefix>
          <SvgIcon local-icon="user" class="text-icon" />
        </template>
      </NInput>
    </NFormItem>
    <NFormItem :label="$t('form.pwd.label')" path="password" :show-require-mark="false">
      <NInput v-model:value="model.password" type="password" show-password-on="click"
        :placeholder="$t('form.pwd.placeHolder')" @keyup.enter="handleSubmit">
        <template #prefix>
          <SvgIcon local-icon="password" class="text-icon" />
        </template>
      </NInput>
    </NFormItem>
    <NSpace vertical :size="24">
      <div class="flex-y-center justify-end">
        <NButton type="primary" quaternary @click="toggleLoginModule('reset-pwd')">
          {{ $t("page.login.pwdLogin.forgetPassword") }}
        </NButton>
      </div>
      <NButton type="primary" block :loading="authStore.loginLoading" @click="handleSubmit">
        {{ $t("page.login.common.loginOrRegister") }}
      </NButton>
    </NSpace>
  </NForm>
</template>

<style scoped></style>
